import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedAdminEmployeesIndexController extends Controller {
  @tracked search = '';
  @tracked sort = '-created-at';
  @tracked plan = '';
  @tracked participationStatus = 'Participating';
  @tracked page = 1;
  @tracked limit = 50;

  queryParams = ['search', 'sort', 'plan', 'participation-status', 'page', 'limit'];
}
